import { AuthLayout } from '../../../components/AuthLayout';
import Logo from '../../../assets/images/logo.png';
import { useMobile } from '../../../hooks/useMobile';
import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../../../store/useAuthStore';

export const LoginPage = () => {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const isMobile = useMobile();

    const login = useAuthStore(state => state.login);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (error) setError('');
    };

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();

        if (!formData.email || !formData.password){
            setError('Please enter your email and password');
            return;
        }

        const result = login(formData);

        if (result.success) {
            navigate('/home'); // Send them to the signed-in homepage
        } else {
            setError(result.message || 'Login failed');
        }
    };

    const labelStyle: React.CSSProperties = {
        display: 'block',
        marginBottom: '8px',
        fontSize: '14px',
        fontWeight: '700',
        color: '#4B5563',
        fontFamily: 'Manrope, sans-serif',
        textAlign: 'left'
    };

    const inputStyle: React.CSSProperties = {
        width: '100%',
        padding: '12px',
        borderRadius: '8px',
        border: 'none',
        color: '#1F2933',
        fontSize: '16px',
        outline: 'none',
        backgroundColor: '#E6E8EC',
        boxSizing: 'border-box',
    };

    return (
        <AuthLayout directory="/role-selection" showBackLink={true}>
            <div style={{ 
                width: isMobile ? '95%' : '75%', 
                backgroundColor: '#fff', 
                margin: '40px auto', 
                borderRadius: '20px', 
                boxShadow: '0px 4px 24px 0px #00000040', 
                padding: '40px 30px', 
                textAlign: 'center', 
                fontFamily: 'Manrope, sans-serif' 
            }}>
                <img src={Logo} alt="Logo" style={{ width: '30%', height: 'auto' }} />
                <h1 style={{ fontSize: '24px', fontWeight: '700', margin: '40px 0px 10px', color: '#1F2933' }}>Welcome Back</h1>
                <p style={{ fontSize: '16px', color: '#4B5563' }}>Log in to your Oya account.</p>

                <form onSubmit={handleLogin} style={{ marginTop: '30px' }}>
                    {error && (
                        <div style={{ backgroundColor: '#FEE2E2', color: '#EF4444', padding: '10px', borderRadius: '8px', marginBottom: '15px', fontSize: '14px', textAlign: 'left' }}>
                            {error}
                        </div>
                    )}
                    <div style={{ textAlign: 'left', marginBottom: '20px' }}>
                        <label style={labelStyle}>Email</label>
                        <input 
                            name="email"
                            type="email" 
                            placeholder="eddy****@gmail.com" 
                            style={inputStyle} 
                            onChange={handleChange}
                        />
                    </div>            

                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <label style={labelStyle}>Password</label>
                            <Link to="/forgot-password" style={{ color: '#D4AF37', fontSize: '14px', fontWeight: '600', textDecoration: 'none', marginBottom: '8px' }}>
                                Forget Password?
                            </Link>
                        </div>
                        <div style={{ position: 'relative' }}>
                            <input 
                                name="password"
                                type={showPassword ? "text" : "password"} 
                                placeholder="************" 
                                style={{ ...inputStyle, paddingRight: '45px' }} 
                                onChange={handleChange}
                            />
                            <div 
                                onClick={() => setShowPassword(!showPassword)} 
                                style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6B7280', display: 'flex', alignItems: 'center' }}
                            >
                                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '30px' }}>
                        <input type="radio" id="remember" style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                        <label htmlFor="remember" style={{ fontSize: '14px', color: '#6B7280', cursor: 'pointer' }}>Remember me</label>
                    </div>

                    <button 
                        type="submit"
                        style={{
                            width: '100%',
                            padding: '16px',
                            backgroundColor: '#1A2238',
                            color: 'white',
                            border: 'none',
                            borderRadius: '12px',
                            fontSize: '18px',
                            fontWeight: '600',
                            cursor: 'pointer'
                        }}
                    >
                        Log in
                    </button>
                </form>

                <p style={{ marginTop: '20px', fontSize: '15px', color: '#6B7280' }}>
                    Don't have an account? <Link to="/role-selection" style={{ color: '#D4AF37', fontWeight: '700', textDecoration: 'none' }}>Create one</Link>
                </p>
            </div>
        </AuthLayout>
    );
};